
import { forwardRef, useEffect, useState } from 'react'

// prop-types is a library for typechecking of props
import PropTypes from 'prop-types'
import Autocomplete from '@mui/material/Autocomplete'
import MDInput from 'components/MDInput'
import { Controller } from 'react-hook-form'

const ZUAutoComplete = forwardRef(({ name, label, control, options, value, getOptionLabel, required, rules, error, onChange: externalOnChange }, ref) => {
  const [selectedValue, setSelectedValue] = useState(value)

  // Update internal state when external value changes
  useEffect(() => {
    setSelectedValue(value)
  }, [value])

  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field: { onChange, value: fieldValue } }) => (
        <Autocomplete
          options={options || []}
          required={required}
          value={selectedValue}
          onChange={(_, item) => {
            // Update React Hook Form
            onChange(item ? item.id : null)
            // Update internal state
            setSelectedValue(item)
            // Call external onChange if provided
            if (externalOnChange) {
              externalOnChange(_, item)
            }
          }}
          getOptionLabel={getOptionLabel}
          isOptionEqualToValue={(item, val) => {
            if (!item || !val) return false
            return item.id === val.id
          }}
          sx={{
            '& .MuiOutlinedInput-root': {
              paddingTop: '5px',
              paddingBottom: '4px'
            }
          }}
          // disableClearable
          renderInput={params => (
            <MDInput
              {...params}
              fullWidth
              required={required}
              label={label}
              error={error}
            />
          )}
        />
      )}
    />
  )
})

// Setting default values for the props
ZUAutoComplete.defaultProps = {
  required: false,
  error: false
}

// Typechecking props for the ZUTitleForm
ZUAutoComplete.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  control: PropTypes.object.isRequired,
  options: PropTypes.array.isRequired,
  value: PropTypes.any,
  rules: PropTypes.object.isRequired,
  getOptionLabel: PropTypes.func.isRequired,
  required: PropTypes.bool,
  error: PropTypes.bool,
  onChange: PropTypes.func
}

export default ZUAutoComplete
